import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';

import {Link} from "react-router-dom";

const mime = 'image/jpg';

export default function PropertyCard({item, onPropertyClicked})
{
    const [selectedCoord, setSelectedCoord] = useState({ lat: 0, lng: 0});

    const  navigate = useNavigate();
    
    useEffect(() => {
        if(typeof onPropertyClicked === 'undefined') return;
        
        onPropertyClicked(onPropertyClicked(selectedCoord))
    }, [selectedCoord]);
    
    const handlePropertyClicked = event => { 
        const {lat,lng} = event;
        
        setSelectedCoord(prevState => ({
            ...prevState, lat, lng
        }));
    };
    
    const handleApplyNowClicked = event => {
        const { id } = event;
        navigate('/hemlaneembed');
        
        console.log(id);
    }

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-US');
    };

    return (
        <div className="col-lg-3 col-md-4 col-12" key={item.key}>
            <div className="card property border-0 shadow position-relative overflow-hidden rounded-3">

                <Link to={`/my-property-detail/${item.id}`} className="title fs-5 text-dark fw-medium">
                    <div className="property-image position-relative overflow-hidden shadow">
                        <img
                            alt={`${item.address}-Unit:${item.unit}`}
                            className="img-fluid" width="255" height="191"
                            src={`data:${mime};base64, ${item.thumbnailImageDef}`}
                        />
                    </div>
                </Link>
                <div className="card-body content p-0" onClick={() => handlePropertyClicked({lat: item.lat, lng: item.lng})}>
                    <ul className="list-unstyled mt-1 py-1 align-items-center justify-content-between">
                        <li className="d-flex align-items-center me-1 ms-2">
                            <p className="p-card letterspacing-1" style={{lineHeight: "1rem"}}>{`${item.address.toUpperCase()}, ${item.city.toUpperCase()} ${item.state.toUpperCase()}`}</p>
                        </li>
                        <li className="d-flex align-items-center me-1 ms-2">
                            <p className="p-card" style={{lineHeight: "1rem"}}>{`UNIT ${item.unit.toUpperCase()}`}  <span style={{fontWeight: "bold"}}>{`$${item.price}/month`}</span></p>
                        </li>
                        <li className="d-flex align-items-center me-1 ms-2">
                            <ul className="list-unstyled d-flex align-items-center justify-content-between">
                                <li className="no-indent"><p className="p-card">{`Beds: ${item.beds}`}</p></li>&nbsp;&nbsp;
                                <li><p className="p-card">{`Baths: ${item.baths}`}</p></li>&nbsp;&nbsp;
                                <li><p className="p-card">{`Sqft: ${item.sqft}`}</p></li>
                            </ul>
                        </li>
                        <li className="d-flex align-items-center me-1 ms-2">
                            <ul className="list-unstyled d-flex align-items-center justify-content-between">
                                <li className="no-indent"><p className="p-card">{`Available: ${item.available === true ? 'Yes' : 'No'}`}</p></li>&nbsp;&nbsp;
                                {item.available ? <li><p className="p-card">{`Date: ${formatDate(item.availableDt)}`}</p></li> : null}
                            </ul>
                        </li>
                        {/*<li><button onClick={()=> handleApplyNowClicked({id:item.id})}>Inquire</button></li>*/}
                    </ul>
                </div>
            </div>
        </div>
    )    
}